'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _immutable = require('immutable');

var Immutable = _interopRequireWildcard(_immutable);

var _exportConstants = require('./exportConstants');

var _popupConstants = require('../../../../components/popupPanel/popupConstants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Constants
var initialState = Immutable.Map(); // Lib

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case _exportConstants.EXPORT_BOARD_FETCH:
            return state.set(action.format, _exportConstants.EXPORT_BOARD_STATES.FETCHING);
        case _exportConstants.EXPORT_BOARD_FAIL:
            return state.set(action.format, _exportConstants.EXPORT_BOARD_STATES.FAILED);
        case _exportConstants.EXPORT_BOARD_SUCCESS:
            return state.set(action.format, action.url);
        case _popupConstants.POPUP_OPEN:
        case _popupConstants.POPUP_CLOSE:
        case _popupConstants.POPUP_TOGGLE:
            return initialState;
        default:
            return state;
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/header/utils/export/exportPopupReducer.js
// module id = 2180
// module chunks = 0